import { render, staticRenderFns } from "./BDXMatchPendingManagerListItem.vue?vue&type=template&id=5f5347b1&scoped=true"
import script from "./BDXMatchPendingManagerListItem.vue?vue&type=script&lang=js"
export * from "./BDXMatchPendingManagerListItem.vue?vue&type=script&lang=js"
import style0 from "./BDXMatchPendingManagerListItem.vue?vue&type=style&index=0&id=5f5347b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5347b1",
  null
  
)

export default component.exports